<template>
    <div class="help-tip">
        <div v-if="visible">
            <div :class="'help-tip-text ' + size + ' ' + side ">
                Click "Get Started" then 'Next' to review and complete your document.
                If you see an error, click on the 'X' above, then click 'continue' to review and edit your data.
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    props: {
      size: {
        default: "small"
      },
      side: {
        default: "right"
      }
    },
    data() {
      return {
        visible: true,
        clicked: false
      }
    },
    methods: {
      onClicked() {
        this.clicked = true;
        this.visible = !this.visible;
      },
      onUnhandledClick() {
        if (!this.clicked) {
          this.visible = false
        }

        this.clicked = false
      }
    },
    events: {
      unhandledClick() {
        if (!this.clicked) {
          this.visible = false;
        }

        this.clicked = false;
      }
    },
    mounted() {
      this.$root.$on('unhandledClick', this.onUnhandledClick);
    }
  }
</script>
